export default __webpack_public_path__ + "static/media/Icon material-work.449b1d3f.svg";